import Lurker from '../lurker'
import Cookie from '../cookie'

class UnsupportedSmartLockError extends Error {
  constructor(...args) {
    super(...args)
    this.code = 'unsupported_smart_lock'
    this.message = 'Unsupported Smart Lock error'
  }
}

const SMART_LOCK_KEY = 'SMART_LOCK_STATUS'
const EXPIRE_DAYS = 30

const changeSmarLockStatus = status => {
  const date = new Date()
  date.setDate(date.getDate() + EXPIRE_DAYS)
  Cookie.create(SMART_LOCK_KEY, status, date.toUTCString())
}

const disableSmartLock = () => {
  changeSmarLockStatus('off')
}

const enableSmartLock = () => {
  changeSmarLockStatus('on')
}

const storeCredential = (email, password, name) => {
  const { PasswordCredential, navigator = {} } = window
  if (PasswordCredential && navigator.credentials) {
    const data = {
      id: email.toLowerCase().trim(),
      password,
    }
    if (name) {
      data[name] = name
    }
    const credentials = new PasswordCredential(data)
    return navigator.credentials.store(credentials)
  }
  return Promise.reject(new UnsupportedSmartLockError())
}

class SmartLock {
  constructor(pageName) {
    this.lurker = new Lurker(pageName)
  }

  isAvailable = () => Cookie.get(SMART_LOCK_KEY) !== 'off'

  saveCredential = (email, password, name = '') =>
    storeCredential(email, password, name)
      .then(() => {
        enableSmartLock()
        this.lurker.viewMessageEvt('save_credentials_success')
      })
      .catch(error => {
        disableSmartLock()
        this.lurker.viewMessageEvt('save_credentials_error', {
          accounts_reason: error.code || 'unknown',
          accounts_error_message: error.message || 'unknown',
        })
      })

  removeCredential = email =>
    storeCredential(email, '-')
      .then(() => {
        this.lurker.viewMessageEvt('remove_credentials_success')
      })
      .catch(error => {
        this.lurker.viewMessageEvt('remove_credentials_error', {
          accounts_reason: error.code || 'unknown',
          accounts_error_message: error.message || 'unknown',
        })
      })

  requestCredential = () => {
    const { navigator = {} } = window
    if (navigator.credentials) {
      return navigator.credentials
        .get({
          password: true,
          unmediated: false,
          mediation: 'required',
        })
        .then(credentials => {
          if (credentials) {
            const { id: email, password } = credentials
            return { email, password }
          }
          disableSmartLock()
          return null
        })
        .catch(error => {
          disableSmartLock()
        })
    }
    disableSmartLock()
    return Promise.resolve()
  }
}

export default SmartLock
